<script>
    import ActionBottom from "../widgets/ActionBottom.svelte";
    import { onDestroy } from 'svelte';
    import store from 'store';
    import { slide } from 'svelte/transition';
    import { cancalAdd,alertinfo } from '../store.js';
    import copy from 'copy-to-clipboard';
    let allredball = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
    ];
    let allblueball = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
    ];
    export let value;
    export let key;
    export let choose_panel;
    export let action_id;
    let saved = false;
    let actived = 'reddan';
    let reddan_isabled = false;
    let actions = {
        copiable: false, //是否可复制
        addable: false, //是否可增加
        reducable: false, //是否可减少
        randable: true,//是否可随机
    };
    const calcBetNum = (redDanLen, redTuoLen, blueDanLen, bluoTuoLen) => {
        return app.combination_sum(5 - redDanLen, redTuoLen) * app.combination_sum(2 - blueDanLen, bluoTuoLen)
    };
    const legal = () => {
        let legalRed = false,legalBlue = false;
        if(value.redtuo.length >= 5 || value.reddan.length+value.redtuo.length >= 6){
            legalRed = true;
        }
        if(value.bluetuo.length >= 2){
            legalBlue = true;
        }
        if(legalRed && legalBlue){
            return true;
        }
        return false;
    }
    $: {
        if(legal()){
            actions.copiable = true;
            if(value.nums <= 1){
                actions.addable = true;
                actions.reducable = false;
            }else if(value.nums >= 99){
                actions.addable = false;
                actions.reducable = true;
            }else{
                actions.addable = true;
                actions.reducable = true;
            }
            value.price = calcBetNum(value.reddan.length,value.redtuo.length,value.bluedan.length,value.bluetuo.length) * 2 * value.nums;
        }else{
            actions.copiable = false;
            actions.addable = false;
            actions.reducable = false;
            value.price = 0;
        }
        if(value.reddan.length == 4){
            reddan_isabled = true;
        }else{
            reddan_isabled = false;
        }
    }

    function choose(e, selectedType, ball) {
        let index = selectedType.indexOf(ball);
        if(selectedType == value.redtuo){
            if(value.reddan.indexOf(ball) != -1){
                return;
            }
        }
        if(selectedType == value.reddan){
            if(value.redtuo.indexOf(ball) != -1){
                return;
            }
        }
        if(selectedType == value.bluetuo){
            if(value.bluedan.indexOf(ball) != -1){
                return;
            }
        }
        if(selectedType == value.bluedan){
            if(value.bluetuo.indexOf(ball) != -1){
                return;
            }
            if(value.bluedan.indexOf(ball) != -1){
                value.bluedan = [];
            }else{
                value.bluedan = [ball];
            }
            value = value;
            return;
        }
        if (index != -1) {
            selectedType.splice(index, 1);
        } else {
            if(selectedType == value.reddan){
                if(value.reddan.length > 3){
                    alertinfo.set('最多4个前区胆')
                    return;
                }
            }
            selectedType.push(ball);
        }
        value = value;
    }
    const handleStore = () => {
        value.reddan = value.reddan || [];
        value.redtuo = value.redtuo || [];
        value.bluedan = value.bluedan || [];
        value.bluetuo = value.bluetuo || [];
        if(legal()){
            saved = true;
            store.set(key, {
                reddan: value.reddan.sort((a, b) => {return a - b}),
                redtuo: value.redtuo.sort((a, b) => {return a - b}),
                bluedan: value.bluedan.sort((a, b) => {return a - b}),
                bluetuo: value.bluetuo.sort((a, b) => {return a - b}),
                nums: 1,
                price: 0
            });
        }
        choose_panel = 0;
        action_id = key;
	}
    const handleAdd = () => {
        value.nums += 1;
    }
    const handleReduce = () => {
        value.nums -= 1;
    }
    const handleCopy = () => {
        let text = 'https://xh.wangzhanb.com/ \r\n';
        text = text.concat('-----------------\r\n');
        text = text.concat('大乐透选号：\r\n');
        text = text.concat('胆拖 - ');
        text = text.concat(value.nums + '倍' + '\r\n');
        if(value.reddan.length > 0){
            text = text.concat('前区胆：' + value.reddan.sort((a, b) => {return a - b}).join('  ') + '\r\n');
        }
        text = text.concat('前区拖：' + value.redtuo.sort((a, b) => {return a - b}).join('  ') + '\r\n');
        if(value.bluedan.length > 0){
            text = text.concat('后区胆：' + value.bluedan.sort((a, b) => {return a - b}).join('  ') + '\r\n');
        }
        text = text.concat('后区拖：' + value.bluetuo.sort((a, b) => {return a - b}).join('  ') + '\r\n');
        copy(text,{
            onCopy: alertinfo.set('内容已复制')
        });
    }
    onDestroy(() => {
        if(saved == false){
            value.reddan = value.reddan || [];
            value.redtuo = value.redtuo || [];
            value.bluedan = value.bluedan || [];
            value.bluetuo = value.bluetuo || [];
            if(value.reddan.length == 0 && value.redtuo.length == 0 && value.bluedan.length == 0 && value.bluetuo.length == 0){
                cancalAdd.set(key);
            }else{
                store.set(key, {
                    reddan: value.reddan.sort((a, b) => {return a - b}),
                    redtuo: value.redtuo.sort((a, b) => {return a - b}),
                    bluedan: value.bluedan.sort((a, b) => {return a - b}),
                    bluetuo: value.bluetuo.sort((a, b) => {return a - b}),
                    nums: 1,
                    price: 0
                });
            }
        }
    })
</script>

<div class="xuanhaoqi" transition:slide="{{duration: 200 }}">
    {#if actived == 'reddan'}
    <div class="ssq-list ssq-red" in:slide="{{duration: 200 }}">
        <div class="panel-tit red-tit" on:click="{() => actived = ''}">前区胆码</div>
        {#each allredball as ball}
            <span
                ><i
                    on:click={(e) => choose(e, value.reddan, ball)}
                    class:selected={value.reddan.indexOf(ball) != -1}
                    class:disabled={(value.reddan.indexOf(ball) == -1 && reddan_isabled) || value.redtuo.indexOf(ball) != -1}
                    >{ball}</i
                ></span
            >
        {/each}
    </div>
    {:else}
    <div class="slt-btn red-btn" on:click="{() => actived = 'reddan'}" in:slide="{{duration: 200 }}">
        <div class="db-tit">前区胆</div>
        {#if value.reddan.length == 0}
        <div class="tip">点击开始选号</div>
        {:else}
        <div class="db-ball ssq-list db-red">
            {#each value.reddan as ball}
            <span><i>{ball}</i></span>
            {/each}
        </div>
        {/if}
    </div>
    {/if}
    {#if actived == 'redtuo'}
    <div class="ssq-list ssq-red" in:slide="{{duration: 200 }}">
        <div class="panel-tit red-tit" on:click="{() => actived = ''}">前区拖码</div>
        {#each allredball as ball}
            <span
                ><i
                    on:click={(e) => choose(e, value.redtuo, ball)}
                    class:selected={value.redtuo.indexOf(ball) != -1}
                    class:disabled={value.reddan.indexOf(ball) != -1}
                    >{ball}</i
                ></span
            >
        {/each}
    </div>
    {:else}
    <div class="slt-btn red-btn" on:click="{() => actived = 'redtuo'}" in:slide="{{duration: 200 }}">
        <div class="db-tit">前区拖</div>
        {#if value.redtuo.length == 0}
        <div class="tip">点击开始选号</div>
        {:else}
        <div class="db-ball ssq-list db-red">
            {#each value.redtuo as ball}
            <span><i>{ball}</i></span>
            {/each}
        </div>
        {/if}
    </div>
    {/if}
    {#if actived == 'bluedan'}
    <div class="ssq-list ssq-blue" in:slide="{{duration: 200 }}">
        <div class="panel-tit blue-tit" on:click="{() => actived = ''}">后区胆码</div>
        {#each allblueball as ball}
            <span
                ><i
                    on:click={(e) => choose(e, value.bluedan, ball)}
                    class:selected={value.bluedan.indexOf(ball) != -1}
                    class:disabled={value.bluetuo.indexOf(ball) != -1}
                    >{ball}</i
                ></span
            >
        {/each}
    </div>
    {:else}
    <div class="slt-btn blue-btn" on:click="{() => actived = 'bluedan'}" in:slide="{{duration: 200 }}">
        <div class="db-tit">后区胆</div>
        {#if value.bluedan.length == 0}
        <div class="tip">点击开始选号</div>
        {:else}
        <div class="db-ball ssq-list db-blue">
            {#each value.bluedan as ball}
            <span><i>{ball}</i></span>
            {/each}
        </div>
        {/if}
    </div>
    {/if}
    {#if actived == 'bluetuo'}
    <div class="ssq-list ssq-blue" in:slide="{{duration: 200 }}">
        <div class="panel-tit blue-tit" on:click="{() => actived = ''}">后区拖码</div>
        {#each allblueball as ball}
            <span
                ><i
                    on:click={(e) => choose(e, value.bluetuo, ball)}
                    class:selected={value.bluetuo.indexOf(ball) != -1}
                    class:disabled={value.bluedan.indexOf(ball) != -1}
                    >{ball}</i
                ></span
            >
        {/each}
    </div>
    {:else}
    <div class="slt-btn blue-btn" on:click="{() => actived = 'bluetuo'}" in:slide="{{duration: 200 }}">
        <div class="db-tit">后区拖</div>
        {#if value.bluetuo.length == 0}
        <div class="tip">点击开始选号</div>
        {:else}
        <div class="db-ball ssq-list db-blue">
            {#each value.bluetuo as ball}
            <span><i>{ball}</i></span>
            {/each}
        </div>
        {/if}
    </div>
    {/if}
    <ActionBottom price={value.price} bind:nums={value.nums} bind:actions ableToRand="{false}" on:store={handleStore} on:copy={handleCopy} on:add={handleAdd} on:reduce={handleReduce}/>
</div>

<style>
    .xuanhaoqi {
        background-color: #fff;
        box-sizing: border-box;
        padding: 0.5rem 0.5rem 0;
        border-radius: 0.9rem;
        width: calc(100% - 1rem);
        margin: 0.2rem auto 0.56rem;
        position: relative;
    }
    .slt-btn{
        width: 100%;
        min-height: 1.85rem;
        border-radius: .6rem;
        position: relative;
        display: flex;
        align-items: center;
        margin: .4rem 0;
    }
    .red-btn{
        background-color: #fde8e8;
    }
    .blue-btn{
        background-color: #e3ecf7;
    }
    .slt-btn .db-tit{
        width: 20%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .76rem;
        font-weight: bold;
    }
    .slt-btn .tip{
        display: flex;
        align-items: center;
        font-size: .76rem;
        color: #aaa;
    }
    .slt-btn .db-ball{
        width: 80%;
        height: 100%;
        padding: .2rem;
        box-sizing: border-box;
    }
    .db-ball i {
        top: 0.1rem !important;
        left: 0.1rem !important;
        height: calc(100% - 0.2rem) !important;
        width: calc(100% - 0.2rem) !important;
    }
    .db-red i{
        background-color: #ff8080;
    }
    .db-blue i{
        background-color: #7fb2e7;
    }
    .panel-tit{
        width: 100%;
        height: .95rem;
        text-align: center;
        line-height: .95rem;
        font-size: .8rem;
        font-weight: bold;
    }
    .red-tit{
        background: linear-gradient( to right,#fff,#fde8e8,#fff);
    }
    .blue-tit{
        background: linear-gradient( to right,#fff,#e3ecf7,#fff);
    }
    .ssq-list {
        position: relative;
        font-size: 0;
    }

    .ssq-list span {
        display: inline-block;
        width: 12.5%;
        position: relative;
        vertical-align: middle;
        text-align: center;
    }

    .ssq-list span:before {
        content: "";
        display: inline-block;
        padding-bottom: 100%;
        width: 0.1rem;
        vertical-align: middle;
    }

    .ssq-list i {
        font-style: normal;
        display: inline-flex;
        position: absolute;
        top: 0.2rem;
        left: 0.2rem;
        height: calc(100% - 0.4rem);
        width: calc(100% - 0.4rem);
        box-sizing: border-box;
        border-radius: 50%;
        font-size: 1rem;
        color: #383838;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        font-family: "Baloo Chettan 2";
    }
    .ssq-list i.disabled::after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .55);
    }

    .ssq-red i {
        background-color: #fba1a1;
    }

    .ssq-blue i {
        background-color: #b2c8df;
    }

    .ssq-red i.selected {
        background-color: red;
        color: #fcfcfc;
    }

    .ssq-blue i.selected {
        background-color: blue;
        color: #fcfcfc;
    }
</style>
